import * as React from 'react';
import createSVGIcon from '../utils/createSVGIcon';

export default createSVGIcon(() => {
  return (
    <path d="M0 0v439h347v73h277v-73h624V0zm69
    73h278v293h-70V146h-69v220H69zm347 0h278v293H555v73H416zm347
    0h416v293h-69V146h-70v220h-69V146h-69v220H763zm-208 73v147h69V146z"/>
  );
}, '0 0 1248 512');
